<app-global-loader *ngIf="loadingVisible"></app-global-loader>
<ng-container *ngIf="logged; else elseBlock">
  <!--Temp Comde-->
  <div class="w-100 d-flex flex-row overflow-hidden">
    <div>
      <app-side-nav (toggleEmitter)="toggleItem($event)"></app-side-nav>
    </div>
    <div [ngClass]="isToggle ? 'w-minus-100': 'w-minus-280'">
      <div class="bg-white w-100" style="height: 100px;">
        <app-header></app-header>
      </div>
      <div style="height: 86vh; padding-left: 0rem; overflow: overlay;">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #elseBlock class="d-flex flex-row overflow-hidden">
  <router-outlet></router-outlet>
</ng-template>
